import { WorkspaceMember, WorkspaceRole } from 'models/user'

export interface ChangeMemberData {
  type: ChangeMemberType
  memberId: WorkspaceMember['userId']
  name: WorkspaceMember['name']
  email: WorkspaceMember['email']
  seatType: WorkspaceMember['seatType']
  newRole: WorkspaceRole
  canOrder?: WorkspaceMember['canOrder']
}

export enum ChangeMemberType {
  ROLE,
  ACCESS,
  CAN_ORDER
}
